import React from "react";
import { Table, Typography, Empty } from "antd";
import { EyeFilled } from "@ant-design/icons";

const { Text } = Typography;

const noWrap = (text) => (
  <span style={{ whiteSpace: "nowrap" }}>{text || "-"}</span>
);

const ServiceInvoiceTable = (props) => {
  const { dataSource, onView } = props;

  const columns = [
    {
      title: <Text strong>Invoice No</Text>,
      dataIndex: "invoiceNumber",
      key: "invoiceNumber",
      width: 120,
      render: (text) => noWrap(text),
    },
    {
      title: <Text strong>Model Code</Text>,
      dataIndex: "jobOrder",
      key: "modelCode",
      width: 110,
      render: (jobOrder) => noWrap(jobOrder?.vehicle?.vehicle?.modelCode),
    },
    {
      title: <Text strong>Model Name</Text>,
      dataIndex: "jobOrder",
      key: "modelName",
      width: 180,
      render: (jobOrder) => noWrap(jobOrder?.vehicle?.vehicle?.modelName),
    },
    {
      title: <Text strong>Chassis No</Text>,
      dataIndex: "jobOrder",
      key: "chassisNo",
      width: 180,
      render: (jobOrder) => noWrap(jobOrder?.vehicle?.chassisNo),
    },
    {
      title: <Text strong>Register No</Text>,
      dataIndex: "jobOrder",
      key: "registerNo",
      width: 120,
      render: (jobOrder) => noWrap(jobOrder?.vehicle?.registerNo),
    },
    {
      title: <Text strong>Branch</Text>,
      dataIndex: "branch",
      key: "branchName",
      width: 130,
      render: (branch) => noWrap(branch?.name),
    },
    {
      title: <Text strong>Action</Text>,
      dataIndex: "id",
      align: "center",
      key: "action",
      width: 80,
      render: (id, record) => (
        <EyeFilled
          style={{ cursor: "pointer", fontSize: "16px" }}
          onClick={() => onView(record)}
        />
      ),
    },
  ];

  return (
    <Table
      className="service-invoice-table"
      locale={{
        emptyText: (
          <Empty
            imageStyle={{ height: 25 }}
            description={
              <Text disabled strong>
                No Service Invoices Found
              </Text>
            }
          />
        ),
      }}
      rowKey={(record) => record.id}
      pagination={false}
      size="small"
      columns={columns}
      dataSource={dataSource}
      tableLayout="fixed"
      scroll={{ x: 920, y: 200 }}
    />
  );
};

export default ServiceInvoiceTable;
